import api from "./client";

export interface DevOpsConfig {
  id: string;
  organization_id: string;
  scenario: 'existing' | 'create' | 'shared';
  azure_devops_org_url?: string;
  new_org_name?: string;
  project_name?: string;
  is_configured: boolean;
  last_tested_at?: string;
  test_status?: string;
  created_at: string;
  updated_at: string;
}

export interface SaveDevOpsConfigData {
  scenario: 'existing' | 'create' | 'shared';
  azureDevOpsOrgUrl?: string;
  azureDevOpsPat?: string;
  newOrgName?: string;
  projectName?: string;
}

export async function getDevOpsConfig(): Promise<{
  configured: boolean;
  config: DevOpsConfig | null;
}> {
  const response = await api.get("/api/devops/config");
  return response.data;
}

export async function saveDevOpsConfig(data: SaveDevOpsConfigData): Promise<{
  message: string;
  config: DevOpsConfig;
}> {
  const response = await api.post("/api/devops/config", data);
  return response.data;
}

export async function deleteDevOpsConfig(): Promise<{ message: string }> {
  const response = await api.delete("/api/devops/config");
  return response.data;
}
